import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  // ---- Public routes (no auth) ----
  {
    path: '01/:gtin/21/:serial',
    loadComponent: () =>
      import('./features/public/public-battery/public-battery').then(
        (m) => m.PublicBattery
      )
  },

  // ---- Protected app routes ----
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard').then((m) => m.Dashboard)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard').then((m) => m.Dashboard)
  },
  {
    path: 'document-types',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/document-types/document-types').then((m) => m.DocumentTypes)
  },
  {
    path: 'battery-models',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/battery-models/battery-models').then((m) => m.BatteryModels)
  },
  {
    path: 'batteries',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/batteries/batteries').then((m) => m.Batteries)
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    data: { roles: ['admin'] },
    loadComponent: () => import('./features/admin/admin').then((m) => m.Admin)
  },
  {
    path: 'forbidden',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/forbidden/forbidden').then((m) => m.Forbidden)
  },
  { path: '**', redirectTo: '' }
];
